// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DriverBasicInfoCmp from "./DriverBasicInfoCmp.bs.js";
import * as DriverDashboardFlow from "../view-modal/DriverDashboardFlow.bs.js";
import * as DriverLeadPageBodyCmp from "./DriverLeadPageBodyCmp.bs.js";
import * as DriverLeadRepoManager from "../../domain/repo/DriverLeadRepoManager.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as DriverBasicInfoVMMapper from "../view-modal/vm-mapper/DriverBasicInfoVMMapper.bs.js";
import * as DriverLeadPageHeaderCmp from "./DriverLeadPageHeaderCmp.bs.js";
import * as DriverLeadPageViewStore from "../view-modal/view-store/DriverLeadPageViewStore.bs.js";
import * as DriverPaymentHistoryCmp from "./DriverPaymentHistoryCmp.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as DriverPartnerPageAssestsManager from "../assets/DriverPartnerPageAssestsManager.bs.js";

DriverPartnerPageAssestsManager.importCss(undefined);

function DriverLeadPageDashboard(Props) {
  var driver_number = Props.driver_number;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var setbasicLeadInfo = match$1[1];
  var basicLeadInfo = match$1[0];
  var fetchDriverLeadBasicInfo = function (param) {
    var RepoInstance = DriverLeadRepoManager.getRepo(undefined);
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(RepoInstance.fetchDriverLeadBasicInfo, driver_number, country);
                }), (function (data) {
                  return Curry._1(setbasicLeadInfo, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setbasicLeadInfo, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          fetchDriverLeadBasicInfo(undefined);
          
        }), []);
  var tmp;
  if (typeof basicLeadInfo === "number") {
    tmp = React.createElement(CircularLoader$Catalyst.make, {});
  } else {
    switch (basicLeadInfo.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case /* Live */1 :
          var responseData = basicLeadInfo._0;
          tmp = Belt_List.toArray(responseData.data).length > 0 ? React.createElement(React.Fragment, undefined, React.createElement(DriverLeadPageHeaderCmp.make, {
                      lead_id: DriverBasicInfoVMMapper.driverLeadPageVM(responseData).lead_id,
                      onboarding_status: DriverBasicInfoVMMapper.getLeadStatus(DriverBasicInfoVMMapper.getDashboardFlow(responseData), responseData),
                      timestamp: DriverBasicInfoVMMapper.driverLeadPageVM(responseData).onboarding_status_timestamp,
                      dashboard_flow: DriverDashboardFlow.toString(DriverBasicInfoVMMapper.getDashboardFlow(responseData))
                    }), React.createElement(DriverLeadPageBodyCmp.make, {
                      children: null
                    }, React.createElement(DriverBasicInfoCmp.make, {
                          basic_info_list: DriverBasicInfoVMMapper.getListOfBasicLeadDetails(responseData)
                        }), React.createElement(DriverPaymentHistoryCmp.make, {
                          lead_id: DriverBasicInfoVMMapper.driverLeadPageVM(responseData).lead_id,
                          country: country
                        }))) : React.createElement("div", {
                  className: "empty-state"
                }, React.createElement("h3", undefined, DriverLeadPageViewStore.empty_lead_data_message));
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: basicLeadInfo._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "driver-lead-dashboard-wrapper"
            }, tmp);
}

var make = DriverLeadPageDashboard;

export {
  make ,
  
}
/*  Not a pure module */
